export default [
  '126.com',
  '163.com',
  'acorns.com',
  'ail.com',
  'aim.com',
  'ameritech.net',
  'aol.com',
  'asu.edu',
  'att.com',
  'att.net',
  'austin.rr.com',
  'bellsouth.net',
  'bigpond.com',
  'btinternet.com',
  'ca.rr.com',
  'cableone.net',
  'carolina.rr.com',
  'centurylink.net',
  'centurytel.net',
  'cfl.rr.com',
  'charter.net',
  'cinci.rr.com',
  'cogeco.ca',
  'comcast.com',
  'comcast.net',
  'cornell.edu',
  'cox.net',
  'cs.com',
  'earthlink.net',
  'eircom.net',
  'email.arizona.edu',
  'embarqmail.com',
  'excite.com',
  'frontier.com',
  'frontiernet.net',
  'fuse.net',
  'gmail.com',
  'gmx.com',
  'gmx.net',
  'google.com',
  'hanmail.net',
  'hawaii.rr.com',
  'hoteltonight.com',
  'hotmail.com',
  'icloud.com',
  'inbox.com',
  'insightbb.com',
  'juno.com',
  'live.com',
  'mac.com',
  'mail.com',
  'mchsi.com',
  'me.com',
  'mindspring.com',
  'msn.com',
  'msu.edu',
  'nate.com',
  'naver.com',
  'nc.rr.com',
  'netscape.net',
  'netzero.com',
  'netzero.net',
  'ntlworld.com',
  'nycap.rr.com',
  'nyu.edu',
  'optonline.net',
  'osu.edu',
  'outlook.com',
  'pacbell.net',
  'post.harvard.edu',
  'prodigy.net',
  'proxymail.facebook.com',
  'ptd.net',
  'q.com',
  'qq.com',
  'rcn.com',
  'roadrunner.com',
  'rochester.rr.com',
  'rocketmail.com',
  'rogers.com',
  'san.rr.com',
  'sasktel.net',
  'sbcglobal.net',
  'sina.com',
  'sky.com',
  'snet.net',
  'suddenlink.net',
  'swbell.net',
  'talktalk.net',
  'tampabay.rr.com',
  'tds.net',
  'telus.net',
  'temple.edu',
  'tx.rr.com',
  'ucdavis.edu',
  'uci.edu',
  'ucla.edu',
  'ufl.edu',
  'umich.edu',
  'umn.edu',
  'unlv.nevada.edu',
  'us.army.mil',
  'usa.net',
  'usc.edu',
  'verizon.net',
  'videotron.ca',
  'vt.edu',
  'walla.com',
  'wi.rr.com',
  'windowslive.com',
  'windstream.net',
  'wowway.com',
  'yahoo.ca',
  'yahoo.com',
  'ymail.com',
]
